import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  GET_STUDENT_STATS,
  GET_TUTOR_STATS,
  GET_MAP,
  GET_STUDENT_CALENDAR,
  GET_STUDENT_PAST_CLASSES,
  GET_TUTOR_PAST_CLASSES,
  GET_STUDENT_UPCOMING_CLASSES,
  GET_TUTOR_UPCOMING_CLASSES,
} from './dashboard.actionTypes'

import DashboardService from 'routing/DashboardService'

import { defaultErrorMessage } from '../../../constants'

export const getTutorStats = createAsyncThunk(GET_TUTOR_STATS, async (data = {}) => {
  try {
    const response = await DashboardService.getTutorStats(
      data.category,
      data.period,
      data.breakdown
    )

    if (response.data?.error || !response.data?.data) {
      throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
    }

    return response.data.data
  } catch (error) {
    console.log(error)
    throw error
  }
})

export const getStudentStats = createAsyncThunk(GET_STUDENT_STATS, async (data = {}) => {
  try {
    const response = await DashboardService.getStudentStats(data.period, data.breakdown)

    if (response.data?.error || !response.data?.data) {
      throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
    }

    return response.data.data
  } catch (error) {
    console.log(error)
    throw error
  }
})

export const getMap = createAsyncThunk(GET_MAP, async () => {
  try {
    const response = await DashboardService.getMap()

    if (response.data?.error || !response.data?.[0]) {
      throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
    }

    return response.data[0]
  } catch (error) {
    console.log(error)
    throw error
  }
})

export const getStudentCalendar = createAsyncThunk(GET_STUDENT_CALENDAR, async () => {
  try {
    const response = await DashboardService.getStudentCalendar()

    if (response.data?.error || !response.data?.data) {
      throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
    }

    return response.data.data.results
  } catch (error) {
    console.log(error)
    throw error
  }
})

export const getTutorPastClasses = createAsyncThunk(
  GET_TUTOR_PAST_CLASSES,
  async (data, { getState }) => {
    try {
      const userId = getState().user.userData.pk

      if (!userId) {
        throw new Error('No id')
      }

      const response = await DashboardService.getTutorPastClasses(userId, data)

      if (response.data?.error) {
        throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
      }

      return response.data
    } catch (error) {
      console.log(error)
      throw error
    }
  }
)

export const getStudentPastClasses = createAsyncThunk(GET_STUDENT_PAST_CLASSES, async (data) => {
  try {
    const response = await DashboardService.getStudentPastClasses(data)

    if (response.data?.error) {
      throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
    }

    return response.data.data
  } catch (error) {
    console.log(error)
    throw error
  }
})

export const getStudentUpcomingClasses = createAsyncThunk(
  GET_STUDENT_UPCOMING_CLASSES,
  async (data) => {
    try {
      const response = await DashboardService.getStudentUpcomingClasses(data)

      if (response.data?.error) {
        throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
      }

      return response.data.data
    } catch (error) {
      console.log(error)
      throw error
    }
  }
)

export const getTutorUpcomingClasses = createAsyncThunk(
  GET_TUTOR_UPCOMING_CLASSES,
  async (data, { getState }) => {
    try {
      const userId = getState().user?.userData?.pk

      if (!userId) {
        throw new Error('No id')
      }

      const response = await DashboardService.getTutorUpcomingClasses(userId, data)

      if (response.data?.error) {
        throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
      }

      return response.data
    } catch (error) {
      console.log(error)
      throw error
    }
  }
)
